import { Component, OnInit, ViewChild, AfterViewInit, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'app-connect',
  templateUrl: './connect.component.html',
  styleUrls: ['./connect.component.scss']
})
export class ConnectComponent implements OnInit {
  constructor() {
  }
  ngOnInit(): void {
  }
}
